import { useState, useContext, useEffect } from "react";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import Swal from "sweetalert2";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Spinner,
} from "react-bootstrap";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";
import { QrReader  } from 'react-qr-reader';
import { QRCodeSVG } from 'qrcode.react';

function LibraryIssuedBook() {
  const { userId, GetstudentData  } = useContext(ProductContext);
  const routes = all_routes;

  const [getLibraryIssueBook, setGetLibraryIssueBook] = useState([]);
  const StudentId = GetstudentData?.id;

  const [showModal, setShowModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showQRScannerId, setShowQRScannerId] = useState(null);

    const authtoken = localStorage.getItem("token");

    const StudentFullName = GetstudentData?.student_full_name;


  const fetchStudentGatePassData = async () => {
    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/transport/issue-book?issued_to_id=${StudentId}`,
        {
          headers: {
            "x-auth": authtoken,
          },
        }
      );
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch Visitor1 data");
      }
      setGetLibraryIssueBook(data);
    } catch (error) {
      console.error("Error fetching Visitor1 data:", error);
    }
  };

  useEffect(() => {
    fetchStudentGatePassData();
  }, [userId]);

  console.log(getLibraryIssueBook, "LibraryIssueBook 1500");

  const QRCodeScanner = ({ visitorId }) => {
    const [scannedId, setScannedId] = useState(null);

    const handleScan = (data) => {
      if (data) {
        try {
          const parsed = JSON.parse(data);
          setScannedId(parsed.id || data);
        } catch {
          setScannedId(data); // fallback if not JSON
        }
      }
    };

    const handleError = (err) => {
      console.error("QR Scan Error:", err);
    };

    return (
      <div style={{ textAlign: "center", padding: "10px" }}>
        <h6>Scanning for ID: {visitorId}</h6>
        <QrReader
          delay={300}
          onError={handleError}
          onScan={handleScan}
          style={{ width: "100%" }}
        />
        {scannedId && (
          <div style={{ marginTop: "10px", fontWeight: "bold" }}>
            ✅ Scanned ID: {scannedId}
          </div>
        )}
      </div>
    );
  };

  const handlePayNow = async (fineAmount, id) => {
const authtoken = localStorage.getItem("token");
  const paymentDetails = {
    amount: fineAmount,
    productinfo: "Book Fine Payment",
    firstname: GetstudentData?.student_full_name,
    email: GetstudentData?.contact_email,
    phone: GetstudentData?.contact_phone,
    issueId: id,
  };

  const query = new URLSearchParams({
    ...paymentDetails,
    authToken: authtoken,
  }).toString();

  const url = `https://admin.mirai.healthcare/pay-u-payment?${query}`;

  // Web browser open
  window.open(url, "_blank");
};

useEffect(() => {
  const currentUrl = window.location.href;

  if (currentUrl.includes("payment-success")) {
    fetchStudentGatePassData();
  } 
  else if (currentUrl.includes("payment-failed")) {
    console.log("");
  }
}, []);

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Header />

        

        <Container fluid>
          <div className="d-flex justify-content-between align-items-center my-2 pb-2">
          <h2
              className="page-title fw-bold mb-0"
              style={{ letterSpacing: "0.5px" }}>Issued Book History</h2>
        </div>
          <Row className="justify-content-left">
            {getLibraryIssueBook?.data?.length > 0 ? (
              getLibraryIssueBook?.data
                ?.sort(
                  (a, b) => new Date(b.created_at) - new Date(a.created_at)
                )
                .map((librarydata, index) => (
                  <Col
                    md={3}
                    lg={3}
                    className="mb-3 justify-content-center"
                    key={librarydata.id}
                  >
                    <Card className="shadow-sm border-0">
                      {librarydata?.book?.book ? (
                        <div>
                          <img
                            src={librarydata?.book?.book}
                            alt="librarydata Document"
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "contain",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedImage(librarydata?.book?.cover_image);
                              setShowImageModal(true);
                            }}
                          />
                        </div>
                      ) : (
                        <ImageWithBasePath
                          src="assets/img/sending-img.png"
                          className="img-fluid"
                          alt="img"
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "contain",
                            cursor: "pointer",
                          }}
                        />
                      )}

                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          padding: "8px",
                          fontSize: "0.9rem",
                        }}
                      >
                        <div className="StudentGateClass_1">
                          <strong>ID:</strong>
                          <span> {librarydata?.id}</span>
                        </div>
                        <div className="StudentGateClass_1">
                          <strong>Title:</strong>
                          <span> {librarydata?.book?.title}</span>
                        </div>
                        <div className="StudentGateClass_1">
                          <strong>Auther name:</strong>
                          <span> {librarydata?.book?.author_name}</span>
                        </div>
                        <div className="StudentGateClass_1">
                          <strong>Publisher Name:</strong>
                          <span> {librarydata?.book?.publisher_name}</span>
                        </div>
                        <div className="StudentGateClass_1">
                          <strong>Issue Book:</strong>
                          <span> {librarydata.issue_date}</span>
                        </div>
                        <div className="StudentGateClass_1">
                          <strong>Due Date:</strong>
                          <span> {librarydata.due_date}</span>
                        </div>
                        {librarydata.book_condition_at_issue && (
                        <div className="StudentGateClass_1">
                          <strong>Book Condition:</strong>{" "}
                          <span>{librarydata.book_condition_at_issue}</span>
                        </div>
                        )}
                        {librarydata.fine_amount && (
                        <div className="StudentGateClass_1">
                          <strong>Fine Amount:</strong>
                          <span> {librarydata.fine_amount}</span>
                        </div>
                        )}

                        <div className="StudentGateClass_1">
                          <strong>Remark Issue:</strong>{" "}
                          <span>{librarydata.remark_at_issue}</span>
                        </div>
                        {librarydata.accession_no && (
                        <div className="StudentGateClass_1">
                          <strong>Accession No.:</strong>
                          <span> {librarydata.accession_no}</span>
                        </div>
                        )}

                        {Number(librarydata?.fine_amount) > 0 && (
  <div className="library-div">
    <button
      className="pay-now-btn btn btn-primary w-100"
      onClick={() => handlePayNow(librarydata?.fine_amount, librarydata?.id)}
    >
      Pay Now
    </button>
  </div>
 )}
                      </div>
                    </Card>
                  </Col>
                ))
            ) : (
              <div className="content row d-flex justify-content-center align-items-center background-color_row_1">
                <Header />
                <ImageWithBasePath
                  src="assets/img/nodata.gif"
                  className="img-fluid"
                  alt="img"
                  width={200}
                />
              </div>
            )}
          </Row>
        </Container>

        <Modal
          show={showImageModal}
          onHide={() => setShowImageModal(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>View Document</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedImage && (
              <img
                src={selectedImage}
                alt="Document"
                style={{ width: "100%", height: "auto" }}
              />
            )}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default LibraryIssuedBook
